module.exports = __webpack_public_path__ + "static/media/pa.0b468e39.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pa.svg
// module id = 1005
// module chunks = 0